
// export const leftFillNum = (num, targetLength) =>
//   num.toString().padStart(targetLength, 0);

// const canvas = document.createElement("canvas")
// canvas.style.position = "absolute"
// canvas.style.left = 0
// canvas.style.top = 0
// canvas.style.zIndex = 1

// canvas.width = 1920
// canvas.height = 1080
// const ctx = canvas.getContext("2d")
// document.body.appendChild(canvas)
// const container = document.createElement('div');
// container.setAttribute("id", "container");
// document.body.appendChild(container);   

// let start = 0; let end = 10;
// const images = []
// for (let index = start; index < end; index++) {
//   let filename = `test-image-sequence/Lil ${leftFillNum(index, 4)}.jpg`
//   let img = new Image();
//   img.src = filename
//   images.push(img)
//   img.onload = () => {
//     console.log("KJSAHD")
//     if (index + 4 === end) {
//       drawinCanvas()
//     }
//   }
// }
// let index = 0;
// let framesPerSecond = 10;
// const drawinCanvas = () => {
//   setTimeout(function () {
//     if (index < images.length) {
//       ctx.drawImage(images[index], 0, 0, 1920, 1080);
//       index++
//     } else {
//       index = 0
//     }
//     requestAnimationFrame(drawinCanvas)
//   }, 1000 / framesPerSecond);
// }



import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);